<template>
  <div class="page-title">
    <div class="page-title-txt">{{ title }}</div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    title: String,
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  display: flex;
  line-height: 36px;
  justify-content: space-between;

  .page-title-txt {
    font-size: 18px;
    color: #333333;
    font-weight: 600;
  }
}
</style>
